declare namespace $ {

	type $shm_tree__roots_shm_hitalama_components_tests_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_tests['tree_roots'] >
		,
		ReturnType< $shm_tree['roots'] >
	>
	type $shm_tree__children_shm_hitalama_components_tests_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_tests['tree_children'] >
		,
		ReturnType< $shm_tree['children'] >
	>
	type $shm_tree__expanded_default_shm_hitalama_components_tests_3 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_tree['expanded_default'] >
	>
	type $shm_tree__Item_shm_hitalama_components_tests_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_tests['Scenario_item'] >
		,
		ReturnType< $shm_tree['Item'] >
	>
	type $mol_view__sub_shm_hitalama_components_tests_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__attr_shm_hitalama_components_tests_6 = $mol_type_enforce<
		({ 
			'selected': ReturnType< $shm_hitalama_components_tests['tree_selected'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__title_shm_hitalama_components_tests_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_tests['tree_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_components_tests_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_tests['choose'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $shm_hitalama_components_tests extends $mol_page {
		content_rows( ): readonly(any)[]
		tree_roots( ): readonly(any)[]
		tree_children( id: any): readonly(any)[]
		tree_selected( id: any): boolean
		tree_title( id: any): string
		choose( id: any, next?: any ): any
		definition( ): $shm_hitalama_map_widget_entity_custom
		selected( next?: string ): string
		title( ): string
		minimal_width( ): number
		body( ): ReturnType< $shm_hitalama_components_tests['content_rows'] >
		Scenarios( ): $shm_tree
		Empty( ): $mol_view
		Scenario_item( id: any): $mol_button_minor
	}
	
}

//# sourceMappingURL=tests.view.tree.d.ts.map